import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from '../components/config';

export const AuthContext = createContext({
  isAuthenticated: false,
  user: null,
  register: () => {},
  login: () => {},
  logout: () => {}
});

const AuthContextProvider = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  const register = async (userData) => {
    try {
      const response = await axios.post(`${config.backendUrl}/api/auth/register`, userData);
      const token = response.data.token;
      localStorage.setItem('token', token);
      setIsAuthenticated(true);
      await fetchUserDetails(token);
    } catch (error) {
      console.error('Error registering user:', error);
      setError(error.response ? error.response.data.message : 'Registration failed');
    }
  };

  const login = async (credentials) => {
    try {
      console.log('Sending login request with credentials:', credentials); // Debug log
      const response = await axios.post(`${config.backendUrl}/api/auth/login`, credentials);
      const token = response.data.token;
      localStorage.setItem('token', token);
      setIsAuthenticated(true);
      await fetchUserDetails(token);
    } catch (error) {
      console.error('Error logging in user:', error);
      console.log('Error details:', error.response); // Debug log
      setError(error.response ? error.response.data.message : 'Login failed');
    }
  };

  const fetchUserDetails = async (token) => {
    try {
      const response = await axios.get(`${config.backendUrl}/api/auth`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Ensure the token is prefixed with "Bearer"
        },
      });
      setUser(response.data);
    } catch (error) {
      console.error('Error fetching user details:', error);
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetchUserDetails(token);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, register, login, logout, error }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;

// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';
// import config from '../components/config';

// export const AuthContext = createContext({
//   isAuthenticated: false,
//   user: null,
//   register: () => {},
//   login: () => {},
//   logout: () => {}
// });

// const AuthContextProvider = (props) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [error, setError] = useState(null);

//   const register = async (userData) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/register`, userData);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error registering user:', error);
//       setError(error.response ? error.response.data.message : 'Registration failed');
//     }
//   };

//   const login = async (credentials) => {
//     try {
//       console.log('Sending login request with credentials:', credentials); // Debug log
//       const response = await axios.post(`${config.backendUrl}/api/auth/login`, credentials);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error logging in user:', error);
//       console.log('Error details:', error.response); // Debug log
//       setError(error.response ? error.response.data.message : 'Login failed');
//     }
//   };

//   const fetchUserDetails = async (token) => {
//     try {
//       const response = await axios.get(`${config.backendUrl}/api/auth`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });
//       setUser(response.data);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setIsAuthenticated(false);
//       setUser(null);
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       fetchUserDetails(token);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, user, register, login, logout, error }}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContextProvider;

// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';
// import config from '../components/config';

// export const AuthContext = createContext({
//   isAuthenticated: false,
//   user: null,
//   register: () => {},
//   login: () => {},
//   logout: () => {}
// });

// const AuthContextProvider = (props) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [error, setError] = useState(null);

//   const register = async (userData) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/register`, userData);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error registering user:', error);
//       setError(error.response ? error.response.data.message : 'Registration failed');
//     }
//   };

//   const login = async (credentials) => {
//     try {
//       console.log('Sending login request with credentials:', credentials); // Debug log
//       const response = await axios.post(`${config.backendUrl}/api/auth/login`, credentials);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error logging in user:', error);
//       console.log('Error details:', error.response); // Debug log
//       setError(error.response ? error.response.data.message : 'Login failed');
//     }
//   };

//   const fetchUserDetails = async (token) => {
//     try {
//       const response = await axios.get(`${config.backendUrl}/api/auth`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });
//       setUser(response.data);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setIsAuthenticated(false);
//       setUser(null);
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       fetchUserDetails(token);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, user, register, login, logout, error }}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContextProvider;

// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';
// import config from '../components/config';

// export const AuthContext = createContext({
//   isAuthenticated: false,
//   user: null,
//   register: () => {},
//   login: () => {},
//   logout: () => {}
// });

// const AuthContextProvider = (props) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [error, setError] = useState(null);

//   const register = async (userData) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/register`, userData);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error registering user:', error);
//       setError(error.response ? error.response.data.message : 'Registration failed');
//     }
//   };

//   const login = async (credentials) => {
//     try {
//       console.log('Sending login request with credentials:', credentials); // Debug log
//       const response = await axios.post(`${config.backendUrl}/api/auth/login`, credentials);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error logging in user:', error);
//       console.log('Error details:', error.response); // Debug log
//       setError(error.response ? error.response.data.message : 'Login failed');
//     }
//   };

//   const fetchUserDetails = async (token) => {
//     try {
//       const response = await axios.get(`${config.backendUrl}/api/auth`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });
//       setUser(response.data);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setIsAuthenticated(false);
//       setUser(null);
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       fetchUserDetails(token);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, user, register, login, logout, error }}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContextProvider;


// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';
// import config from '../components/config';

// export const AuthContext = createContext({
//   isAuthenticated: false,
//   user: null,
//   register: () => {},
//   login: () => {},
//   logout: () => {}
// });

// const AuthContextProvider = (props) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);

//   const register = async (userData) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/register`, userData);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error registering user:', error);
//       throw error;
//     }
//   };

//   const login = async (credentials) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/login`, credentials);
//       const token = response.data.token;
//       localStorage.setItem('token', token);
//       setIsAuthenticated(true);
//       await fetchUserDetails(token);
//     } catch (error) {
//       console.error('Error logging in user:', error);
//       throw error;
//     }
//   };

//   const fetchUserDetails = async (token) => {
//     try {
//       const response = await axios.get(`${config.backendUrl}/api/auth`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });
//       setUser(response.data);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setIsAuthenticated(false);
//       setUser(null);
//       throw error;
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       fetchUserDetails(token);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, user, register, login, logout }}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContextProvider;


// import React, { createContext, useState } from 'react';
// import axios from 'axios';
// import config from '../components/config';

// export const AuthContext = createContext();

// const AuthContextProvider = (props) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   const register = async (userData) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/register`, userData);
//       setIsAuthenticated(true);
//       // Store token in localStorage or any other state management solution
//     } catch (error) {
//       console.error('Error registering user:', error);
//       throw error;
//     }
//   };

//   const login = async (credentials) => {
//     try {
//       const response = await axios.post(`${config.backendUrl}/api/auth/login`, credentials);
//       setIsAuthenticated(true);
//       // Store token in localStorage or any other state management solution
//     } catch (error) {
//       console.error('Error logging in user:', error);
//       throw error;
//     }
//   };

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, register, login }}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContextProvider;

// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';

// export const AuthContext = createContext();

// const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const checkLoggedIn = async () => {
//       const token = localStorage.getItem('token');
//       if (token) {
//         axios.defaults.headers.common['x-auth-token'] = token;
//         try {
//           const res = await axios.get('/api/auth');
//           setUser(res.data);
//         } catch (err) {
//           console.error(err);
//         }
//       }
//       setLoading(false);
//     };
//     checkLoggedIn();
//   }, []);

//   const login = async (email, password) => {
//     const res = await axios.post('/api/auth/Login', { email, password });
//     localStorage.setItem('token', res.data.token);
//     axios.defaults.headers.common['x-auth-token'] = res.data.token;
//     setUser(res.data.user);
//   };

//   const register = async (name, email, password) => {
//     const res = await axios.post('/api/auth/register', { name, email, password });
//     localStorage.setItem('token', res.data.token);
//     axios.defaults.headers.common['x-auth-token'] = res.data.token;
//     setUser(res.data.user);
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     delete axios.defaults.headers.common['x-auth-token'];
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, register, logout, loading }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthProvider;
